<template>
  <div v-if="$store.getters.appInfo">
    <v-app-bar
      absolute
      elevation="0"
      class="app-style navbar"
      :color="colorBar"
      dense
    >
      <Logo />
      <v-spacer></v-spacer>
      <v-col
        v-if="$vuetify.breakpoint.mdAndUp"
        cols="auto"
        class="test_orange mt-3"
      >
        <v-tabs centered class="tabsBackground" align-with-title>
          <v-tab
            v-if="$store.getters.appInfo.requireHomePage"
            :to="{ name: 'Home' }"
            :active-class="activeTab"
            :exact-path="true"
          >
            <span class="font_tabs" v-text="$t('sections.home')" />
          </v-tab>
          <v-tab
            v-if="$route.name == 'Discovery'"
            :to="{ name: 'Discovery' }"
            :active-class="activeTab"
          >
            <span class="font_tabs" v-text="$t('sections.discovery')" />
          </v-tab>

          <MenuStores v-if="$store.getters.appInfo.storeListRequired" />

          <v-tab v-if="$store.getters.isAdmin" :to="{ name: 'Dashboard' }">
            <span class="font_tabs" v-text="$t('sections.dashboard')" />
          </v-tab>

          <v-btn
            v-if="!$store.getters.checkAuth"
            class="btn px-5"
            height="50px"
            text
            color="primary"
            @click="showAuth = true"
          >
            <span class="font_tabs" v-text="$t('general.login')" />
          </v-btn>
          <v-btn
            v-if="!$store.getters.checkAuth"
            class="btn px-5"
            height="50px"
            text
            color="primary"
            @click="showAuth = true"
          >
            <span class="font_tabs" v-text="$t('general.sign_up')" />
          </v-btn>
        </v-tabs>
      </v-col>
      <template v-else>
        <div class="mt-3">
          <MenuStores v-if="$store.getters.appInfo.storeListRequired" />
        </div>
      </template>
      <div class="mt-3">
        <Language />
      </div>
      <div class="px-2 mt-3">
        <ProfileCustomer />
      </div>

      <v-app-bar-nav-icon
        v-show="$vuetify.breakpoint.smAndDown"
        class="primary--text mt-3"
        x-large
        @click.stop="drawer = !drawer"
      />
    </v-app-bar>
    <v-navigation-drawer
      v-if="$vuetify.breakpoint.smAndDown"
      v-model="drawer"
      app
      right
      fixed
      temporary
      :width="width"
      color="white"
    >
      <v-app-bar
        absolute
        color="gray"
        elevation="0"
        height="80"
        class="px-5"
        rounded="rounded-t-xl"
      >
        <v-row justify="end">
          <v-btn icon @click.stop="drawer = !drawer">
            <v-icon color="primary" large v-text="'mdi-close'" />
          </v-btn>
        </v-row>
      </v-app-bar>
      <v-container mt-15 pt-10 px-7 class="test_red">
        <v-row no-gutters class="test_blue">
          <v-list nav expand class="test_yellow" width="100%">
            <v-list-item
              v-if="$store.getters.appInfo.requireHomePage"
              :to="{ name: 'Home' }"
              active-class="active"
              :exact-path="true"
            >
              <v-list-item-title
                class="item-title"
                v-text="$t('sections.home')"
              />
            </v-list-item>
            <v-list-item
              v-if="$route.name != 'Home'"
              :to="{ name: 'Discovery' }"
              active-class="active"
              :exact-path="false"
            >
              <v-list-item-title
                class="item-title"
                v-text="$t('sections.discovery')"
              />
            </v-list-item>
            <v-list-item
              v-if="$store.getters.isAdmin"
              active-class="active"
              :to="{ name: 'Dashboard' }"
            >
              <v-list-item-title
                class="item-title"
                v-text="$t('sections.dashboard')"
              />
            </v-list-item>
            <v-list-item
              v-if="!$store.getters.checkAuth"
              active-class="active"
              @click="showAuth = true"
              @click.stop="drawer = !drawer"
            >
              <v-list-item-title
                class="item-title"
                v-text="$t('general.login')"
              />
            </v-list-item>
            <v-list-item
              v-if="!$store.getters.checkAuth"
              active-class="active"
              @click="showAuth = true"
              @click.stop="drawer = !drawer"
            >
              <v-list-item-title
                class="item-title"
                v-text="$t('general.sign_up')"
              />
            </v-list-item>
          </v-list>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-dialog
      v-model="showAuth"
      persistent
      max-width="550"
      :fullscreen="$vuetify.breakpoint.mobile"
      transition="dialog-bottom-transition"
      :content-class="$vuetify.breakpoint.mobile ? '' : 'dialog-rounded'"
      :scrollable="false"
    >
      <ModalAuthForm v-if="showAuth" v-model="showAuth" />
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "MenuHeaderPublic",
  data: () => ({
    drawer: false,
    showAuth: false,
    storeList: false,
  }),
  computed: {
    colorBar() {
      // if (this.$store.getters.appInfo.five) {
      //   return this.$store.getters.appInfo.five;
      // } else {
      //   return "black";
      // }
      return "#FFFFFF";
    },
    activeTab() {
      return "link-active";
    },
    width: function () {
      switch (true) {
        case this.$vuetify.breakpoint.xsOnly:
          return "100%";
        case this.$vuetify.breakpoint.smOnly:
          return "60%";
        case this.$vuetify.breakpoint.mdOnly:
          return "50%";
        case this.$vuetify.breakpoint.lgAndUp:
          return "30%";
        default:
          return "100%";
      }
    },
  },

  methods: {
    logout: async function () {
      this.$store.dispatch("loading/start");
      await this.$store.dispatch("auth/logout");
      this.$router.push("/");
      this.$store.dispatch("loading/done");
    },
  },
};
</script>
<style>
.tabsBackground .v-item-group.v-slide-group.v-tabs-bar {
  background-color: transparent;
}
</style>
<style lang="scss" scoped>
.font_tabs {
  font-family: $font_Regular;
  font-size: 1.2rem;
  color: #000 !important;
}

.navbar {
  max-width: 1400px;
  margin: 0 auto;
  padding: 10px 0;
  //display: flex;
  align-items: center;
  justify-content: center;
  min-height: 90px !important;
}
.navbar div {
  padding: 0 !important;
}

@media screen and (max-width: 768px) {
  .navbar {
    max-width: none;
  }
}

.link-active .font_tabs {
  color: var(--v-primary-base) !important;
}

.v-tab {
  text-transform: none !important;
}

.v-tab:hover {
  opacity: 0.7;
}

.btn {
  font-family: $font_Bold;
  text-transform: none;
  font-size: 1rem;
  padding: 2rem;
}
.item-title {
  // color: var(--v-five-base);
  color: black !important;
}
.active,
.active .item-title {
  color: var(--v-primary-base) !important;
}
//IPAD VERTICAL
@media only screen and (min-width: 768px) and (max-width: 999px) and (orientation: portrait) {
  .v-list-item .v-list-item__subtitle,
  .v-list-item .v-list-item__title {
    line-height: 2.2 !important;
  }
  .v-list-item__title {
    align-self: center;
    font-size: 1.7rem !important;
  }
}

//IPAD LANDSCAPE
@media only screen and (min-width: 1000px) and (max-width: 1169px) and (orientation: landscape) {
  .v-list-item .v-list-item__subtitle,
  .v-list-item .v-list-item__title {
    line-height: 2.5 !important;
  }
  .v-list-item__title {
    align-self: center;
    font-size: 1.5rem !important;
  }
}
</style>
